import { useRef, useState } from 'react';
import { downloadFile } from '@intelligence/utils/commonUtils';

import type { IVideo } from '../types';
import type { IVideoPlayerInstance } from '../components/VideoPlayer';

export default function usePlayVideoEffect() {
  const player = useRef<IVideoPlayerInstance>(null);
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState('');
  const [poster, setPoster] = useState('');
  const [video, setVideo] = useState<IVideo | null>(null);

  const handlePlayPre = (video: IVideo) => {
    if (!video?.concat_video_url) return;
    setUrl(video?.concat_video_url);
    setPoster(video?.concat_video_cover);
    setVideo(video);
    setVisible(true);
  };

  const handleDownload = (urlKey: keyof IVideo) => {
    const videoUrl = video?.[urlKey];
    if (!videoUrl) return;
    const downloadUrl =
      videoUrl?.indexOf('?') === -1
        ? `${videoUrl}?response-content-disposition=attachment`
        : `${videoUrl}&response-content-disposition=attachment`;
    downloadFile({
      url: downloadUrl,
      fileName: 'true',
    });
  };

  const handleClose = () => {
    player.current?.pause();
    setVisible(false);
  };

  return {
    player,
    visible,
    url,
    poster,
    onPlayPre: handlePlayPre,
    onDownload: handleDownload,
    onClose: handleClose,
  };
}
